module.exports = __webpack_public_path__ + "static/turtle-creek-house13-2cef212aea6bca318db45fbf632d9014.jpg";